// extracted by mini-css-extract-plugin
export default {"modal":"InputModal__modal__9EUJG","wrapper":"InputModal__wrapper__JdY+L","action":"InputModal__action__F9cpW","save":"InputModal__save__EaeGG","cancel":"InputModal__cancel__JBAZb"};